import React, { PropsWithChildren } from "react"

import { getConfig } from "@cirrus/config"
import { useHttp } from "@cirrus/core/http/provider"

import { NewsProvider } from "./context"
import { NewsServiceHttp } from "./service"

const config = getConfig()

export const NewsDecorator = ({children}: PropsWithChildren) => {
  const { http } = useHttp()

  return <NewsProvider service={new NewsServiceHttp(config.Customer, http)}>{children}</NewsProvider>
}
